<template>
  <span v-if="labels">{{ labels }}</span>
  <span v-else>{{ t('lumia.transversal') }}</span>
</template>
<script lang="ts" setup>
  import { computed } from 'vue'
  import { useI18n } from 'vue-i18n'
  import type { LessonImpulseCodeName } from '../models/lesson-impulse'

  interface Props {
    subjects: ReadonlyArray<LessonImpulseCodeName>
  }

  const props = defineProps<Props>()
  const { t } = useI18n()

  const labels = computed(() => {
    if (props.subjects.length === 0) {
      return null
    }
    return props.subjects
      .map((subject) => (subject.name.length > 20 ? subject.code : subject.name))
      .join(', ')
  })
</script>
